/** Height of the fixed app header in pixels. Matches Tailwind's h-16 (4rem). */
export const APP_HEADER_HEIGHT_PX = 64

/** Height of the collapsed profile bar in pixels. Matches Tailwind's h-10 (2.5rem). */
export const COLLAPSED_PROFILE_BAR_HEIGHT_PX = 40

/**
 * BottomNav's icon row height in pixels: matches its `pt-[11px]` + `h-[42px]` icon row.
 * Excludes the bottom safe-area inset, which BottomNav and the floating Compose button
 * each add separately via `env(safe-area-inset-bottom)`.
 */
export const BOTTOM_NAV_CONTENT_HEIGHT_PX = 53

/** BottomNav's minimum bottom padding in pixels when there is no safe-area inset. Matches its `pb-[max(11px, env(safe-area-inset-bottom))]`. */
export const BOTTOM_NAV_MIN_BOTTOM_PADDING_PX = 11
